import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ToastContainer } from 'react-toastify';
import getGACode from './utils/tracking';
import getCarriers from './actions/carriers';
import Header from './components/nav/Header';
import Landing from './components/landing';
import Dashboard from './components/Dashboard';
import StaleClientToast from './components/common/StaleClientToast';
import { validateTheme } from './actions/theme';
import { validateClient } from './actions/session';

import './styles/theme.scss';
import 'react-toastify/dist/ReactToastify.css';
import { WithTrackerGA4 } from './common/components';
import PR from './components/common/ProtectedRoute';
import StandaloneUserDetails from './components/user-admin/StandaloneUserDetails';
import PublicDisruptionReport from './components/standalone-disruption';

class App extends React.PureComponent {
  componentDidMount() {
    // Setup Google Analytics.
    getGACode().then((code) => {
      ReactGA.initialize(code);
      ReactGA.send({ hitType: 'pageview', page: (window.location.pathname + window.location.search) });
    });

    // Rehydrate the carrier cache.
    getCarriers();

    if (!window.location.pathname.includes('error_')) {
      // Validate the client version and update if needed.
      validateClient();
      window.setInterval(validateClient, 8000);
    }

    // Validate the theme version and update if needed.
    validateTheme();
    window.setInterval(validateTheme, 8000);

    try {
      // Update favicon from Redux cache.
      const { favicon } = this.props;
      document.getElementById('favicon').href = favicon;
    } catch {} // eslint-disable-line
  }

  componentDidUpdate() {
    try {
      // Update favicon from Redux cache.
      const { favicon } = this.props;
      document.getElementById('favicon').href = favicon;
    } catch {} // eslint-disable-line
  }

  handleDragEnter = () => {
    const { openDropzone, ready, isDragging } = this.props;

    if (ready && !isDragging) {
      openDropzone();
    }
  };

  render() {
    return (
      <BrowserRouter>
        <div id="subroot" onDragEnter={this.handleDragEnter}>
          <Header />
          <WithTrackerGA4>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/florida-strong" element={<PublicDisruptionReport state="fl" />} />
              <Route path="/north-carolina-strong" element={<PublicDisruptionReport state="nc" />} />
              <Route path="*" element={<PR><Dashboard /></PR>} />
              <Route path="/admin/:username" element={<PR><StandaloneUserDetails /></PR>} />
            </Routes>
          </WithTrackerGA4>

          <StaleClientToast />

          <ToastContainer
            position="top-center"
            autoClose={2800}
            hideProgressBar={false}
            newestOnTop
            closeOnClick={false}
            rtl={false}
            pauseOnVisibilityChange
            draggable={false}
            pauseOnHover={false}
            style={{ zIndex: 100005 }}
          />
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (store) => ({
  isDragging: store.batch.dragging,
  ready: store.batch.ready,
  favicon: store.theme.favicon,
});

const mapDispatchToProps = {
  openDropzone: () => ({ type: 'OPEN_DROPZONE' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
